<template>
  <b-modal id="anketa-modal"
           size="xl"
           :title="$t('questionnaire')"
           @show="getAnketa"
           @hide="onHide"
           centered>
    <div class="mb-4" v-if="patient">{{ patient.full_name }}</div>
    <div class="row no-print row-narrow" v-if="editable">
      <div class="col">
        <input type="text" :placeholder="$t('add_question')"
               class="form-control"
               v-model="newQuestionText"/>
      </div>
      <div class="col col-auto">
        <button @click="addQuestion"
                :disabled="newQuestionText.length === 0"
                :loading="loading"
                class="btn-themed btn-themed-squared btn-themed-outline h-100">
          {{ $t('add') }}
        </button>
      </div>
    </div>
<!--    <div class="py-5 text-center" v-if="loading">-->
<!--      <b-spinner label="Spinning"></b-spinner>-->
<!--    </div>-->
    <div class="mt-5">
      <div v-for="(a, aind) in anketa"
           :key="`anketa-id-${a.id}`">
        <div v-if="aind === 0 || (a.category !== anketa[(aind - 1)].category)"
             class="mt-3 mb-2">
          <h4 class="font-weight-bold text-center">{{ $t(anketaDictionary[a.category]) }}</h4>
        </div>
        <div class="row mb-2">
          <div class="col-md col-12">
            <div class="question-title">
              <div>{{ a.name }}</div>
              <div class="small text-muted position-relative d-none">
                {{ $t('ask_for_details_on_response') }}:
                <span class="">
                  {{ $t(a.ask_details_on) }}
                </span>
                <SwitchGroup @input="toggleQuestionDetails(a)"
                             v-if="editable"
                             class="switch-on-hover ml-2"
                             :value="a.ask_details_on === 'yes'"/>
              </div>
              <a class="pointer delete-trash"
                 v-if="editable"
                 @click="deleteQuestion(a.id)">
                <TrashSvg/>
              </a>
            </div>
          </div>
          <div class="mt-md-0 mt-2 col-md-auto col-12">
            <div class="radio-inline">
              <RadioGroup :options="responses"
                          v-model="a.response"
                          :validationId="`response-${a.id}`"/>
            </div>
            <AutosizeTextArea v-model="a.details"
                              :minH="20"
                              :rows="1"
                              v-if="showDetailsField(a)"
                              :placeholder="$t('tell_more')"
                              :showlabel="false"/>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer="{ close }">
      <div class="modal-footer-buttons no-print">
        <b-button class="cancel mr-md-3 mr-2 d-inline-block align-middle"
                  variant="themed"
                  @click="close()">
          {{ $t('cancel') }}
        </b-button>
        <button @click="print"
                class="btn-themed align-middle btn-themed-squared mr-md-3 mr-2">
          {{ $t('print_noun') }}
        </button>
        <button @click="printEmpty"
                class="d-none d-md-inline btn-themed align-middle btn-themed-squared mw-auto w-auto px-3 mr-md-3 mr-2">
          {{ $t('print_empty') }}
        </button>
        <button :disabled="loading"
                @click="save"
                class="btn-themed align-middle btn-themed-squared">
          {{ $t('save') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>

import { EloquentService } from "@/services/api/eloquent.api.service"
import { PatientService } from "@/services/api/patient.api.service"
import { mapState } from "vuex"
import RadioGroup from "@/components/form/RadioGroup"
import TrashSvg from '@/assets/svg-vue/general/trash.svg'
import {anketaCategories} from "@/dictionaries/dictionary"
import JwtService from "@/services/jwt.service"
import SwitchGroup from "@/components/form/SwitchGroup.vue"
import AutosizeTextArea from "@/components/form/AutosizeTextArea.vue"

export default {
  name: "PatientAnketaModal",
  components: {
    AutosizeTextArea,
    SwitchGroup,
    RadioGroup,
    TrashSvg
  },
  computed: {
    ...mapState({
      patient: state => state.patient.patient,
      loading: state => state.dom.loading,
      clinic: state => state.auth.clinic
    }),
  },
  data() {
    return {
      anketa: [],
      newQuestionText: '',
      anketaDictionary: anketaCategories,
      responses: [
        { id: '1', title: 'yes' },
        { id: '2', title: 'no' },
        { id: '0', title: 'unknown' },
      ],
      editable: false
    }
  },
  methods: {
    getAnketa() {
      PatientService.getClientAnketa(this.patient.id).then(res => {
        this.anketa = res.data
      })
    },
    save() {
      PatientService.saveClientAnketa(this.patient.id, { anketa: this.anketa }).then(res => {
        this.anketa = res.data
        this.$bvModal.hide('anketa-modal')
      })
    },
    addQuestion() {
      let formData = new FormData()
      formData.append('name', this.newQuestionText)
      EloquentService.create('anketa_question', formData).then(() => this.getAnketa())
    },
    deleteQuestion(id) {
      EloquentService.delete('anketa_question', id).then(() => this.getAnketa())
    },
    async toggleQuestionDetails(question) {
      let formData = new FormData()
      formData.append('ask_details_on', question.ask_details_on === 'yes' ? 'no' : 'yes')
      try {
        await EloquentService.update('anketa_question', question.id, formData)
        this.getAnketa()
      } catch (e) {
        console.log(e)
      }
    },
    async print() {
      await PatientService.saveClientAnketa(this.patient.id, { anketa: this.anketa })
      let link = JwtService.getPrintPrelink(this.clinic)
      window.open(link+'/anketa/'+this.patient.id, '_blank')
    },
    printEmpty() {
      let link = JwtService.getPrintPrelink(this.clinic)
      window.open(link+'/anketa/'+this.patient.id+"?empty=1", '_blank')
    },
    onHide() {
      this.anketa = []
      this.newQuestionText = ''
    },
    showDetailsField(a) {
      const resp = Number(a.response)
      return (resp === 2 && a.ask_details_on === 'no')
          || (resp === 1 && a.ask_details_on === 'yes')
    }
  },
}
</script>

<style scoped lang="scss">
.question-title {
  position: relative;
  .delete-trash {
    position: absolute;
    top: -13px;
    left: -13px;
    display: none;
  }
  &:hover {
    .delete-trash, .switch-on-hover {
      display: inline-block;
    }
  }
  .switch-on-hover {
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}

@media screen and (max-width: 768px) {
  .modal-dialog .modal-content .modal-footer .modal-footer-buttons .btn-themed {
    width: 95px;
  }
}
</style>
